﻿import { Suspense } from 'react';

import type { ComponentType } from 'react';

// project imports
import PageSkeleton from './PageSkeleton';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = <P extends object>(Component: ComponentType<P>) => (props: P) => {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <Component {...props} />
    </Suspense>
  );
};

export default Loadable;

